<template>
  <v-app>
    <v-main class="charcoal">
      <v-container id="core-view" fill-height>
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {};
</script>
